import { browser } from "$app/environment"
import { writable } from "svelte/store"

export function persistentWritable<T>(def: T, key: string) {
  let write = writable(def)
  const value = window?.localStorage?.getItem?.(key)
  if (browser && value !== null && value !== "") {
    try {
      write = writable(JSON.parse(value))
    } catch (err) {
      console.error("write store",err)
    }
  }

  write.subscribe((val) => {
    try {
      const string = JSON.stringify(val)
      window.localStorage.setItem(key, string)
    } catch (err) { console.error("subscribe store",err) }

  })

  return write
}
